import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCustomGeoZones(companyId, query) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].getCustomGeoZones,
		{
			urlParams: {
				companyId,
			},
			params: query,
		}
	)
}

function getCustomGeoZone(companyId, customGeoZoneId) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].getCustomGeoZone,
		{
			urlParams: {
				companyId,
				customGeoZoneId,
			},
		}
	)
}

function getCustomGeoZonePopup(companyId, customGeoZoneId) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].getCustomGeoZonePopup,
		{
			urlParams: {
				companyId,
				customGeoZoneId,
			},
		}
	)
}

function getCustomGeoZonePreview(companyId, customGeoZoneId) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].getCustomGeoZonePreview,
		{
			urlParams: {
				companyId,
				customGeoZoneId,
			},
		}
	)
}

function createCustomGeoZone(companyId, data) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].createCustomGeoZone,
		{
			urlParams: {
				companyId,
			},
			...data,
		}
	)
}

function putCustomGeoZone(companyId, customGeoZoneId, data) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].putCustomGeoZone,
		{
			urlParams: {
				companyId,
				customGeoZoneId,
			},
			...data,
		}
	)
}

function patchCustomGeoZone(companyId, customGeoZoneId, data) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].patchCustomGeoZone,
		{
			urlParams: {
				companyId,
				customGeoZoneId,
			},
			...data,
		}
	)
}

function deleteCustomGeoZone(companyId, customGeoZoneId) {
	return dataTransferWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		dtConfig[ModulesMap.CUSTOM_GEO_ZONES].deleteCustomGeoZone,
		{
			urlParams: {
				companyId,
				customGeoZoneId,
			},
		}
	)
}


export default {
	getCustomGeoZones,
	getCustomGeoZone,
	createCustomGeoZone,
	putCustomGeoZone,
	patchCustomGeoZone,
	deleteCustomGeoZone,
	getCustomGeoZonePreview,
	getCustomGeoZonePopup,
}

